package com.eladfinish.bible.contest.screens.search.usecases.root

import com.eladfinish.bible.contest.common.usecases.getSpecificVerse.GetSpecificVerseV3UseCase
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel

interface RootSearchVerseProvider {

    operator fun invoke(
        bookIndex: Int,
        chapterIndex: Int,
        verseIndex: Int,
        onlyQri: Boolean = true,
    ): VerseUiModel?

    suspend fun prefetch(bookAndChapterIndexes: List<Pair<Int, Int>>)
}

class RootSearchVerseProviderImpl(
    private val getSpecificVerseV3UseCase: GetSpecificVerseV3UseCase,
) : RootSearchVerseProvider {

    override fun invoke(
        bookIndex: Int,
        chapterIndex: Int,
        verseIndex: Int,
        onlyQri: Boolean,
    ): VerseUiModel? =
        getSpecificVerseV3UseCase(
            bookIndex = bookIndex,
            chapterIndex = chapterIndex,
            verseIndex = verseIndex,
            onlyQri = onlyQri,
        )

    override suspend fun prefetch(bookAndChapterIndexes: List<Pair<Int, Int>>) {
        getSpecificVerseV3UseCase.prefetch(bookAndChapterIndexes)
    }
}
